import Root from "./src/app/dashboard";
import { mountComponent, defineCustomElement } from "@weave-framework/runtime/dom";
mountComponent(Root, "#app");